var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZenonNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 117,
    viewBox: "0 0 406 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V14.2236H46.3119L0 43.1131V116H12.5504V79.6671L59.2294 116H72V45.1029H23.633L72 14.0025V0ZM59.2294 59.1792V97.0597L12.5504 59.1792H59.2294Z",
    fill: "url(#paint0_linear_4_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.404 0.8252V5.90335L90.8223 39.0383H113.293V47.2903H78V42.1487L99.6456 9.01372H79.9678V0.8252H112.404Z",
    fill: "url(#paint1_linear_4_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.369 27.6759H128.516V39.2287H150.289V47.2903H119.312V0.8252H149.591V8.82329H128.516V19.7413H147.369V27.6759Z",
    fill: "url(#paint2_linear_4_4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.358 0.8252L187.892 31.548V0.8252H196.462V47.2903H188.972L166.374 16.504V47.2903H157.931V0.8252H165.358Z",
    fill: "url(#paint3_linear_4_4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.937 23.9943C203.937 19.1277 204.91 14.8748 206.857 11.2354C208.804 7.59607 211.449 4.82424 214.792 2.91994C218.177 0.973312 221.943 0 226.091 0C230.238 0 233.983 0.973312 237.326 2.91994C240.711 4.82424 243.377 7.59607 245.324 11.2354C247.313 14.8748 248.308 19.1277 248.308 23.9943C248.308 28.9031 247.313 33.1773 245.324 36.8166C243.377 40.4559 240.711 43.2489 237.326 45.1956C233.983 47.0999 230.238 48.052 226.091 48.052C221.943 48.052 218.177 47.0999 214.792 45.1956C211.449 43.2489 208.804 40.4559 206.857 36.8166C204.91 33.1773 203.937 28.9031 203.937 23.9943ZM213.649 23.9943C213.649 27.0835 214.157 29.813 215.173 32.1828C216.231 34.5526 217.691 36.3934 219.552 37.7053C221.457 38.9748 223.636 39.6096 226.091 39.6096C228.545 39.6096 230.703 38.9748 232.565 37.7053C234.47 36.3934 235.93 34.5526 236.945 32.1828C238.003 29.813 238.532 27.0835 238.532 23.9943C238.532 20.9051 238.003 18.1967 236.945 15.8692C235.93 13.4994 234.47 11.6798 232.565 10.4102C230.703 9.09836 228.545 8.44243 226.091 8.44243C223.636 8.44243 221.457 9.09836 219.552 10.4102C217.691 11.6798 216.231 13.4994 215.173 15.8692C214.157 18.1967 213.649 20.9051 213.649 23.9943Z",
    fill: "url(#paint4_linear_4_4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M263.301 0.8252L285.835 31.548V0.8252H294.405V47.2903H286.914L264.317 16.504V47.2903H255.874V0.8252H263.301Z",
    fill: "url(#paint5_linear_4_4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2354 69.5051L111.77 100.228V69.5051H120.339V115.97H112.849L90.251 85.1839V115.97H81.8086V69.5051H89.2354Z",
    fill: "url(#paint6_linear_4_4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.093 96.3558H139.24V107.909H161.013V115.97H130.036V69.5051H160.315V77.5032H139.24V88.4212H158.093V96.3558Z",
    fill: "url(#paint7_linear_4_4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.276 69.5051H201.727V77.6936H187.635V115.97H178.367V77.6936H164.276V69.5051Z",
    fill: "url(#paint8_linear_4_4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.556 69.5051L249.205 100.736L258.091 69.5051H266.978L252.505 115.97H245.396L235.621 85.6283L226.163 115.97H219.117L204.009 69.5051H213.531L223.052 100.736L232.193 69.5051H239.556Z",
    fill: "url(#paint9_linear_4_4)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.468 92.6742C268.468 87.8076 269.441 83.5547 271.388 79.9153C273.334 76.276 275.979 73.5042 279.322 71.5999C282.708 69.6532 286.474 68.6799 290.621 68.6799C294.768 68.6799 298.514 69.6532 301.857 71.5999C305.242 73.5042 307.908 76.276 309.855 79.9153C311.844 83.5547 312.838 87.8076 312.838 92.6742C312.838 97.5831 311.844 101.857 309.855 105.497C307.908 109.136 305.242 111.929 301.857 113.875C298.514 115.78 294.768 116.732 290.621 116.732C286.474 116.732 282.708 115.78 279.322 113.875C275.979 111.929 273.334 109.136 271.388 105.497C269.441 101.857 268.468 97.5831 268.468 92.6742ZM278.18 92.6742C278.18 95.7634 278.688 98.4929 279.703 100.863C280.761 103.233 282.221 105.073 284.083 106.385C285.988 107.655 288.167 108.29 290.621 108.29C293.076 108.29 295.234 107.655 297.096 106.385C299 105.073 300.46 103.233 301.476 100.863C302.534 98.4929 303.063 95.7634 303.063 92.6742C303.063 89.585 302.534 86.8766 301.476 84.5491C300.46 82.1793 299 80.3597 297.096 79.0901C295.234 77.7783 293.076 77.1223 290.621 77.1223C288.167 77.1223 285.988 77.7783 284.083 79.0901C282.221 80.3597 280.761 82.1793 279.703 84.5491C278.688 86.8766 278.18 89.585 278.18 92.6742Z",
    fill: "url(#paint10_linear_4_4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M358.999 115.97L348.017 115.907L336.718 99.2123H329.609V115.97H320.405V69.5051H336.465C340.104 69.5051 343.299 70.1187 346.05 71.346C348.8 72.5732 350.916 74.3294 352.397 76.6145C353.878 78.8574 354.619 81.4388 354.619 84.3587C354.619 87.321 353.857 89.9235 352.334 92.1664C350.81 94.4092 348.673 96.1231 345.923 97.308L358.999 115.97ZM329.609 77.3128V91.4047H335.385C338.094 91.4047 340.337 90.8334 342.114 89.6908C343.934 88.5059 344.843 86.7285 344.843 84.3587C344.843 81.9466 343.955 80.1692 342.177 79.0267C340.4 77.8841 338.136 77.3128 335.385 77.3128H329.609Z",
    fill: "url(#paint11_linear_4_4)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M386.013 88.4847L405.754 115.97H393.884L379.411 95.5306L373.063 102.323V115.97H363.859V69.5051H373.063V91.1507L392.36 69.5051H403.85L386.013 88.4847Z",
    fill: "url(#paint12_linear_4_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_4",
    x1: 35.9633,
    y1: 0,
    x2: 35.9633,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FF34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD926",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4_4",
    x1: 241.877,
    y1: 27.5189,
    x2: 68.0758,
    y2: 27.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB42F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenonNetwork);
export default __webpack_public_path__ + "static/media/zenon-network.65ab85fce2bca3b94b860404ae5ddfa9.svg";
export { ForwardRef as ReactComponent };